import { FC } from "react";
import SmartSearchMonthYearAndActionsLayout from "../../../components/Layouts/smart-search-month-year-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetBingoAccountParams,
  getBingoAccount,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {SearchStatusEnum} from "../../../enums/searchStatusEnum";
import dayjs from "dayjs";

const BingoAccount: FC = () => {
  return (
    <SmartSearchMonthYearAndActionsLayout
      searchBy={[SearchOptionEnum.DISTRIBUTOR, SearchOptionEnum.CHARITY]}
      status={SearchStatusEnum.ACTIVE + "," + SearchStatusEnum.CLOSED}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      minYear={2014}
      validOnEmpty
      onRefresh={(output, month, year, params) => {
        const getBingoAccountParams: GetBingoAccountParams = {
          output,
          month: dayjs()
            .set("date", 1)
            .set("year", Number(year))
            .set("month", Number(month))
            .format("YYYY-MM-DD"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getBingoAccountParams[id as "distributorId" | "charityId"] =
            params.id;
        }

        return getBingoAccount(getBingoAccountParams);
      }}
    />
  );
};

export default BingoAccount;
